import { Component, input } from '@angular/core';

@Component({
  selector: 'app-debug-instance',
  imports: [],
  templateUrl: './debug-instance.component.html',
  styleUrl: './debug-instance.component.css',
})
export class DebugInstanceComponent {
  instance = input.required<{ name?: string } | undefined>();
}
